<template>
  <div
    class="mx-auto flex flex-col gap-12 max-w-7xl px-4 py-8 sm:px-6 lg:px-8 sm:py-16"
  >
    <div
      class="flex flex-col gap-12 w-full rounded-2xl border border-gray-200 shadow-sm bg-white py-8 px-4 sm:py-16 sm:px-28"
    >
      <div
        class="flex flex-col items-center justify-center gap-4 w-full max-w-[800px] mx-auto text-center sm:gap-2"
      >
        <h1
          class="text-pretty text-3xl font-medium tracking-tight text-gray-900 sm:text-4xl lg:text-balance"
        >
          Integrate with ease
        </h1>
        <p
          class="text-lg sm:text-xl sm:leading-[30px] text-gray-700 text-pretty"
        >
          Seamlessly integrate with your favorite tools and services
        </p>
      </div>

      <div class="grid grid-cols-1 gap-8 sm:grid-cols-3 sm:gap-16">
        <div
          v-for="(integration, index) in integrationElements"
          :key="integration.name"
          class="flex flex-col items-center justify-center text-center gap-2 bg-white"
          :class="[index === 1 && 'sm:row-span-2']"
        >
          <template v-if="index === 1">
            <div class="hidden sm:block">
              <img
                :src="ClickButtonIcon"
                alt="integration-icon"
                class="size-[220px]"
              >
            </div>
          </template>
          <template v-else>
            <div
              class="mb-2 flex items-center justify-center rounded-xl bg-[linear-gradient(180deg,_#FFFFFF_0%,_#F9FAFB_100%)] border border-[#E9D7FE] shadow p-2.5 size-12"
            >
              <img
                :src="integration.icon"
                alt="integration-icon"
                class="size-7"
              >
            </div>
            <h3 class="font-semibold text-gray-900">
              {{ integration.name }}
            </h3>
            <p class="text-sm text-gray-700">
              {{ integration.description }}
            </p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import DMMLogo from "@/../images/integration-icons/dmm-logo.svg";
import PostgridIcon from "@/../images/integration-icons/postgrid-icon.svg";
import ShopifyIcon from "@/../images/integration-icons/shopify-icon.svg";
import LobIcon from "@/../images/integration-icons/lob-icon.svg";
import ClickButtonIcon from "@/../images/integration-icons/click-button-icon.svg";
import { useBreakpoints } from "@vueuse/core";

const breakpoints = useBreakpoints({
    mobile: 0,
    tablet: 640,
    laptop: 1024,
    desktop: 1280,
});

const isMobile = breakpoints.between("mobile", "tablet");

const integrationElements = ref([
    {
        name: "Direct Mail Manager",
        description:
            "Simplify your workflow by seamles integrating our tool with your website or application.",
        icon: DMMLogo,
    },
    {
        icon: ClickButtonIcon,
    },
    {
        name: "Postgrid",
        description:
            "Simplify your workflow by seamles integrating our tool with your website or application.",
        icon: PostgridIcon,
    },
    {
        name: "Shopify",
        description:
            "Simplify your workflow by seamles integrating our tool with your website or application.",
        icon: ShopifyIcon,
    },
    {
        name: "Lob",
        description:
            "Simplify your workflow by seamles integrating our tool with your website or application.",
        icon: LobIcon,
    },
]);

onMounted(() => {
    if (isMobile.value) {
        integrationElements.value.splice(1, 1);
    }
});
</script>
